import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { isoToTR, trToISO } from "@/lib/dateTR";

/**
 * DateInputTR — GG.AA.YYYY formatında görünen tarih inputu.
 * value  : ISO string "YYYY-MM-DD" (veya boş)
 * onChange(iso) : tam ve geçerli girişte ISO string döndürür ("" temizlendiğinde)
 *
 * Otomatik nokta ekler (12 → 12. → 12.03 → 12.03. → 12.03.2026)
 * Sadece rakam/nokta kabul eder, uzunluk 10 ile sınırlı.
 */
export function DateInputTR({ value, onChange, className, ...rest }) {
  const [text, setText] = useState(isoToTR(value));

  useEffect(() => {
    // Dışarıdan gelen value değişirse görünen metni senkronla (edit mode load vb.)
    const tr = isoToTR(value);
    if (tr !== text) setText(tr);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = (e) => {
    let raw = (e.target.value || "").replace(/[^\d.]/g, "");
    // Fazlalık noktaları temizle: en fazla 2 nokta olsun
    // Sadece rakamları alıp doğru pozisyonlara nokta koyarak yeniden yaz
    const digits = raw.replace(/\./g, "").slice(0, 8);
    let out = digits;
    if (digits.length > 4) out = `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`;
    else if (digits.length > 2) out = `${digits.slice(0, 2)}.${digits.slice(2)}`;

    setText(out);

    if (out === "") { onChange?.(""); return; }
    const iso = trToISO(out);
    if (iso) onChange?.(iso);
  };

  const handleBlur = () => {
    // Eksik/eksik-formatlı girişte gösterimi son iso ile senkronla
    const iso = trToISO(text);
    if (!iso) setText(isoToTR(value));
  };

  return (
    <Input
      type="text"
      inputMode="numeric"
      placeholder="GG.AA.YYYY"
      maxLength={10}
      value={text}
      onChange={handleChange}
      onBlur={handleBlur}
      className={`font-mono ${className || ""}`}
      {...rest}
    />
  );
}
